// Ajax library
import axios from 'axios'

// import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css'

import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import './plugins/vuetify'

Vue.use(Vuex);
Vue.use(VueAxios, axios);

import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

// Application router
import router from './router'


// other utils
import print from 'vue-print-nb'

Vue.use(print);

// 自定义的工具函数
import utils from './utils'

window.xutil = utils;

Array.prototype.clone = function () {
    return this.slice(0);
};

Array.prototype.unique = function (mutate) {
    const unique = this.reduce(function (accum, current) {
        if (accum.indexOf(current) < 0) {
            accum.push(current);
        }
        return accum;
    }, []);
    if (mutate) {
        this.length = 0;
        for (let i = 0; i < unique.length; ++i) {
            this.push(unique[i]);
        }
        return this;
    }
    return unique;
};

Vue.config.productionTip = true;

import VueXStore from './store'

const store = VueXStore.getStore();


/**
 * 人民币金额格式化
 */
Vue.filter('currency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('zh-Hans-CN', {
        style: 'currency',
        currency: 'CNY',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

/**
 * 格式化时间戳
 */
Vue.filter('timestamp', function (value) {
    return value && value.slice(0, -5).replace('T', ' ')
});

Vue.filter('datetime', function (value) {
    return value && value.slice(0, -8).replace('T', ' ')
});

/**
 * 格式化文件大小
 */
Vue.filter('fileSize', function (size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
    }
    return size.toString() + ' B'
});

/**
 * 格式化百分比
 */
Vue.filter('percent', function (value) {
    const v = Math.round(Number(value) * 100) / 100;
    return v.toString() + '%';
});

// 请求拦截器, 附加用户、角色信息
Vue.axios.interceptors.request.use(
    function (config) {
        // 如果用户已经登录，则在请求中生成 X-AUTH-TOKEN 头信息
        if (store.getters.userId) {
            //console.log(" in Vue.axios.interceptors.request");
            config.headers['X-AUTH-TOKEN'] =
                window.xutil.token(
                    config.method,
                    config.url.split('?')[0], // 只要请求路径
                    config.data ? JSON.stringify(config.data).length : 0,
                    store.getters.username,
                    store.getters.password,
                    store.getters.deptId,
                    store.getters.roleId
                );
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// 直接输入地址时的，登录拦截器，在未登录时跳转登录页面
router.beforeEach(
    (to, from, next) => {
        //console.log("in $router.beforeEach");

        if (to.matched.some(record => record.meta.public !== true)) {
            // this route requires auth, check if logged in
            // if not, redirect to login page.
            if (!store.getters.userId) {
                next({
                    path: '/login',
                    query: {redirect: to.fullPath}
                })
            } else {
                next()
            }
        } else {
            next() // 确保一定要调用 next()
        }
    });

/* eslint-disable no-new */
// Vue.use(Vuetify, {
//     lang: {
//         locales: {zhHans},
//         current: 'zhHans'
//     }
// });

// new Vue({
//     el: '#app',
//     store,
//     router,
//     components: {App},
//     template: '<App/>'
// });

import App from './App.vue'

new Vue({
    store,
    router,
    render: h => h(App),
    // lang: {
    //     locales: {zhHans},
    //     current: 'zhHans',
    // },
}).$mount('#app')
